"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    form: {
      type: Object
    },
    rules: {
      type: Object
    },
    containerTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    cargoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showdisabled: {
      type: Boolean,
      default: true
    },
    bkPreContainerDiff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titleFlag: {
      type: String,
      default: ''
    },
    preLockFlag: {
      type: Boolean,
      default: null
    }
  },
  data: function data() {
    return {
      pickerStartDate: function pickerStartDate(idx) {
        var self = this;
        return {
          disabledDate: function disabledDate(time) {
            if (self.form.webBkPreContainerComs[idx].returnDate) {
              var returnDate = new Date(self.form.webBkPreContainerComs[idx].returnDate);
              return time.getTime() > returnDate.getTime();
            } else {
              return false;
            }
          },
          shortcuts: [{
            text: this.$t('home.newToday'),
            onClick: function onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }]
        };
      },
      pickerCloseDate: function pickerCloseDate(idx) {
        var self = this;
        return {
          disabledDate: function disabledDate(time) {
            if (self.form.webBkPreContainerComs[idx].pickUpDate == '') {
              return false;
            }
            return time.getTime() < new Date(self.form.webBkPreContainerComs[idx].pickUpDate);
          },
          shortcuts: [{
            text: this.$t('home.newToday'),
            onClick: function onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }]
        };
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])), {}, {
    total: function total() {
      return this.form.webBkPreContainerComs.filter(function (item) {
        return item.containerType && item.quantity;
      }) // 过滤掉 containerType 和 quantity 为空或无效的项
      .map(function (item) {
        return "".concat(item.containerType, "*").concat(item.quantity);
      }) // 对剩余的项进行拼接
      .join(';'); // 用分号连接所有项
    }
  }),
  methods: {
    tableClass: function tableClass(fileName) {
      return {
        'different': this.isDifferent(fileName)
      };
    },
    isDifferent: function isDifferent(fileName) {
      var bkPreContainerDiff = this.bkPreContainerDiff;
      // let bkPreContainerDiff  =  ["containerType0","quantity0","cargoTypeCode0","pickUpDate0","returnDate0","pickUpDepot0","returnDepot0"]
      return bkPreContainerDiff.includes(fileName);
    },
    handleRemoveBox: function handleRemoveBox(row, index) {
      console.log(row, '0000000000000');
      if (row.bookingHeadWebComId || row.tempBookingHeadComId) {
        row.rowStatus = 8;
        console.log(row, '0003330000000000');
        this.form.deleteWebBkPreContainerComs.push(row);
      }
      this.form.webBkPreContainerComs.splice(index, 1);
    },
    handleAddBox: function handleAddBox() {
      var data = {
        containerType: '',
        quantity: null,
        cargoTypeCode: '',
        pickUpDate: '',
        returnDate: '',
        pickUpDepot: '',
        returnDepot: '',
        id: '',
        rowStatus: 4
      };
      this.form.webBkPreContainerComs.push(data);
    }
  }
};